export default {
	INGREDIENTS: 'Ingredients',
	INGREDIENT_TRANSLATIONS: 'Ingredient translations',
	INGREDIENT_COMPONENTS: 'Ingredient components',
	GLOBAL_INGREDIENT_COMPONENTS: 'Global ingredient components',
};
